var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hygiene"},[_c('div',{staticClass:"head"},[_c('Navigator'),_c('h3',[_vm._v("医疗卫生")]),_c('p',[_vm._v("Medical care")])],1),_c('Content',{attrs:{"data":_vm.content}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }